import axios from 'axios';

export async function getStudentOfferGrabon() {
  const url = 'https://api.studentoffers.info/Grabons';
  return axios({
    method: 'GET',
    url
  });
}

export async function getStudentOfferCustomOffers() {
  const url = 'https://api.studentoffers.info/custom-offers';
  return axios({
    method: 'GET',
    url
  });
}

export async function getStudentOfferFromCMS() {
  const url = 'https://cms.fainlearn.com/offers?_limit=-1';
  return axios({
    method: 'GET',
    url
  });
}

export async function getStudentOfferCategory() {
  const url = 'https://cms.fainlearn.com/offers-categories?_sort=category_name:ASC';
  return axios({
    method: 'GET',
    url
  });
}
